import { createContext } from 'react';
import { QUERY_KEYS_BENEFITS, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useIgdFiltersContext } from '../../../Common/Filters/hooks/useIgdFiltersContext';

export const FamilyAllowanceChartsDataContext = createContext();

const FamilyAllowanceChartsDataProvider = ({ children }) => {
    const { filters } = useIgdFiltersContext();

    const filterParams = {
        year: filters?.year?.value ?? '',
        month: filters?.month?.value ?? '',
        location: filters?.unidade?.value ?? '',
        city: filters?.cidade?.value ?? ''
    };

    const {data, isLoading, isError} = useChartsData(
        {
            key: QUERY_KEYS_BENEFITS.BENEFITS_FAMILY_ALLOWANCE_TRANSFER_VALUES_FAMILIES,
            url: 'governanceroom/socialdashboard/benefits/familyAllowanceTransferValues/families'
        },
        filterParams
    );

    const valuesQuery = useChartsData(
        {
            key: QUERY_KEYS_BENEFITS.BENEFITS_FAMILY_ALLOWANCE_TRANSFER_VALUES_VALUES,
            url: 'governanceroom/socialdashboard/benefits/familyAllowanceTransferValues/values'
        },
        filterParams
    );

    const averageValuesQuery = useChartsData(
        {
            key: QUERY_KEYS_BENEFITS.BENEFITS_FAMILY_ALLOWANCE_TRANSFER_VALUES_AVERAGE_VALUES,
            url: 'governanceroom/socialdashboard/benefits/familyAllowanceTransferValues/averageValues'
        },
        filterParams
    );

    const chartData = {
        families: {
            annual: data?.anualEvolution ?? [],
            monthly: data?.monthEvolution ?? []
        },

        values: {
            annual: valuesQuery.data?.anualEvolution ?? [],
            monthly: valuesQuery.data?.monthEvolution ?? []
        },

        averageValues: {
            annual: averageValuesQuery.data?.anualEvolution ?? [],
            monthly: averageValuesQuery.data?.monthEvolution ?? []
        }
    };

    return (
        <FamilyAllowanceChartsDataContext.Provider
            value={{
                chartData,
                filters,
                filterParams,
                isLoading,
                isError,
                data
            }}
        >
            {children}
        </FamilyAllowanceChartsDataContext.Provider>
    );
};

export default FamilyAllowanceChartsDataProvider;
